import { useState } from "react";
import { CATEGORIES } from "../data/products";

export default function AdminAddProduct() {
  const [formData, setFormData] = useState({
    id: `p_${Date.now()}`,
    name: "",
    category: CATEGORIES[0], // ✅ FIXED
    price: "",
    originalPrice: "",
    description: "",
    imageUrl: "",
    stock: "50",
    bestseller: false,
    rating: "0",
    reviewsCount: "0",
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value, type } = e.target;

    if (type === "checkbox") {
      const checked = (e.target as HTMLInputElement).checked;
      setFormData((prev) => ({ ...prev, [name]: checked }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const newProduct = {
      ...formData,
      slug: formData.name.toLowerCase().replace(/\s+/g, "-"), // ✅ added (required in Product)
      category: formData.category, // ✅ string category
      price: Number(formData.price),
      originalPrice: formData.originalPrice
        ? Number(formData.originalPrice)
        : undefined,
      stock: Number(formData.stock),
      rating: Number(formData.rating),
      reviewsCount: Number(formData.reviewsCount),
      isInStock: Number(formData.stock) > 0, // ✅ required field
      features: [],
      variants: [],
    };

    console.log("=== NEW PRODUCT GENERATED ===");
    console.log(JSON.stringify(newProduct, null, 2));
    alert("Product data logged! Press F12 → Console to copy.");
  };

  return (
    <div className="container" style={{ maxWidth: "800px" }}>
      <h1>Admin: Draft New Product</h1>

      <form
        onSubmit={handleSubmit}
        className="card"
        style={{ display: "grid", gap: "16px", padding: "24px" }}
      >
        {/* Name */}
        <div>
          <label>Product Name</label>
          <input
            required
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        {/* Category */}
        <div>
          <label>Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
          >
            {CATEGORIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {/* Price */}
        <div>
          <label>Price</label>
          <input
            required
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
          />
        </div>

        {/* Image */}
        <div>
          <label>Image URL</label>
          <input
            required
            type="text"
            name="imageUrl"
            value={formData.imageUrl}
            onChange={handleChange}
          />
        </div>

        {/* Description */}
        <div>
          <label>Description</label>
          <textarea
            required
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        {/* Stock */}
        <div>
          <label>Stock</label>
          <input
            type="number"
            name="stock"
            value={formData.stock}
            onChange={handleChange}
          />
        </div>

        {/* Bestseller */}
        <label>
          <input
            type="checkbox"
            name="bestseller"
            checked={formData.bestseller}
            onChange={handleChange}
          />
          Bestseller
        </label>

        <button type="submit">Generate Product</button>
      </form>
    </div>
  );
}
